import { Button, Stack, Typography } from "@mui/material"
import { ExitIcon } from "../../assets/svgs/ExitIcon"
import { ReactElement } from "react";
import { useAuth } from "../../assets/contexts/AuthContext";

interface HeaderProps {
  title?: string;
  toolbarButtons?: ReactElement;
  titleElement?: ReactElement;
}

export const Header = ({ title, toolbarButtons, titleElement }: HeaderProps) => {
  const { signOut } = useAuth();

  const onExit = () => {
    signOut();
  }

  return (
    <Stack 
      className="header" 
      direction='row' 
      alignItems='center' 
      justifyContent='space-between' 
      height='100px'
      sx={{ background: '#F4F4F4' }}
      pl={4}
      pr={4}
    >
      <Stack className="header-left" direction='row' alignItems='center'>
        {
          titleElement 
            ? titleElement
            : <Typography variant="h4" fontWeight="600" fontFamily="korolev-condensed">{title}</Typography>
        }
      </Stack>
      <Stack className="header-right" direction='row' alignItems='center' justifyContent='flex-end' spacing={2}>
        {toolbarButtons}
        <Button sx={{ minWidth: 0, minHeight: 0, width: '40px', height: '40px' }} onClick={() => onExit()}>
          <ExitIcon />
        </Button>
      </Stack>
    </Stack>
  )
}